import { useTranslation } from 'react-i18next';

import './SocialMediaSharing.scss';
import Icon from 'components/purpur/Icon/Icon';

enum SocialMedia {
  LINKEDIN = 'linkedin',
  FACEBOOK = 'facebook',
  TWITTER = 'x',
}

const getIcon = (icon: SocialMedia) => {
  switch (icon) {
    case SocialMedia.LINKEDIN:
      return 'linkedin';
    case SocialMedia.FACEBOOK:
      return 'facebook';
    case SocialMedia.TWITTER:
      return 'x';
  }
};

export const SocialMediaSharing = () => {
  const canUseShareApi = !!navigator.share;
  const isMobile = /Android|iPad|iPhone|iPod|BlackBerry|webOS/i.test(navigator.userAgent);
  const link = document.URL;
  const { t } = useTranslation();

  const buildSocialMediaLink = (type: SocialMedia) => {
    switch (type) {
      case SocialMedia.LINKEDIN:
        return `https://www.linkedin.com/shareArticle?url=${link}`;
      case SocialMedia.FACEBOOK:
        return `https://www.facebook.com/sharer/sharer.php?u=${link}`;
      case SocialMedia.TWITTER:
        return `https://twitter.com/intent/tweet?url=${link}`;
      default:
        return `${link}`;
    }
  };

  const share = async () => {
    await navigator.share({
      url: link,
    });
  };

  const buildSocialMediaIcon = (type: SocialMedia) => {
    return (
      <a
        href={buildSocialMediaLink(type)}
        aria-label={`Share on ${type}`}
        data-testid={`social-${type}-icon`}
        target="_blank"
        rel="noreferrer"
        className="social__icon"
      >
        <Icon iconName={getIcon(type)} size="md" />
      </a>
    );
  };

  if (canUseShareApi && isMobile) {
    return (
      <div className="social" data-testid="social">
        <div className="social__share-text">{t('actions.share')}</div>
        <div className="social__icon" data-testid="social-share-icon" onClick={share}>
          <Icon iconName={'share'} size="sm" />
        </div>
      </div>
    );
  } else {
    return (
      <div className="social" data-testid="social">
        <div className="social__share-text">{t('actions.share')}</div>
        {buildSocialMediaIcon(SocialMedia.LINKEDIN)}
        {buildSocialMediaIcon(SocialMedia.FACEBOOK)}
        {buildSocialMediaIcon(SocialMedia.TWITTER)}
      </div>
    );
  }
};
